<template>
    <DialogueBox :blur="false" :left="91" :top="125" :width="1087" :height="638">
        <div class="greeting-text" v-html="T(myUser.greeting)"></div>
        <AvatarCircle :size="310" :sizeInner="204" :id="myUser._id" :isSelected="false" :selectable="false"
            :isReserved="false" :style="{ top: '136px', left: '108px', position: 'absolute' }">
        </AvatarCircle>
        <div class="intro-text">
            <div v-html="T(myUser.intro)"></div>
        </div>

        <div v-if="offline" class="shared-back-button-dialogue" @click="$emit('back')">
            <div v-html="T('button_back')"></div>
        </div>

        <div class="shared-continue-button-dialogue" @click="$emit('continue-clicked')">
            <div v-html="T('button_continue')"></div>
        </div>

    </DialogueBox>


</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue, { PropType } from 'vue';
import DialogueBox from "../components/DialogueBox.vue";
import room_user from '../../../shared_fca/room_user';
import Game, { getUser } from '../../../shared_fca/game';
import AvatarCircle from "../components/AvatarCircle.vue";

export default Vue.extend({
    name: 'PlayerInfo',
    components: {
        DialogueBox,
        AvatarCircle,
    },
    props: {
        game: Object as PropType<Game>,
        myUUID: String,
        offline: Boolean,
    },
    computed: {

        myUser: {
            cache: false,
            get(): room_user {
                return getUser(this.game, this.myUUID);
            }
        },
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.continue-button {
    height: 50px;
    width: 162px;
    border-radius: 8px;
    background-color: #B2CD30;
    color: #ffffff;
    font-family: Rubik;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    position: absolute;
    margin-top: 31px;
}

.greeting-text {
    color: #636252;
    top: 114px;
    left: 475px;
    width: 490px;
    position: absolute;
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.intro-text {
    height: 279px;
    width: 490px;
    left: 474px;
    top: 164px;
    position: absolute;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #333333;
}
</style>
